import { injectDataCy, KdsLink, KdsText } from "@kazaar-platform/design-system";
import { useTranslate } from "@tolgee/react";
import dayjs from "dayjs";
import { type DeliveryBlocProps } from "./DeliveryBloc.types";
import { DeliverySummary } from "./DeliverySummary";

export const DeliveryBloc = ({
  orderItem,
  onTabNavigation,
}: DeliveryBlocProps) => {
  const { t } = useTranslate();

  return (
    <section
      className="flex flex-col gap-4 rounded-br-8 rounded-br-br-8 bg-white p-6"
      {...injectDataCy("orderItemDeliverySummary")}
    >
      <div className="flex flex-wrap items-center gap-2">
        <KdsText as="h2" size="title-sm">
          {t("cardAddress.title")}
        </KdsText>
      </div>
      {orderItem.sandboxItem.dispatchType === "dispatchFiles" ? (
        <div className="flex flex-col items-start gap-2">
          <KdsText size="subtitle-sm">
            {t(
              "order.catalogMediumConfiguration.stepDelivery.addressBlock.fileDispatch"
            )}
          </KdsText>

          <KdsLink size="sm" onPress={() => onTabNavigation?.("documents")}>
            {t("orderItemSummary.details.dispatchLink")}
          </KdsLink>
        </div>
      ) : (
        <DeliverySummary orderItem={orderItem} />
      )}

      <div className="mt-4 flex flex-col gap-sp-sm">
        <KdsText size="subtitle-sm">
          {t("orderItemSummary.details.deliveryDate")}
        </KdsText>
        <KdsText>
          {dayjs(orderItem.sandboxItem.deliveryDate).format("L")}
        </KdsText>
      </div>
    </section>
  );
};
